<button class="btn btn-secondary" (click)="nextCaptureClick()" [disabled]="isDisabled">
  @if (isDisabled) {
    <fa-icon [icon]="['fas', 'circle-notch']" size="sm" [animation]="'spin'" />
  }
  NEXT
</button>
